import { mdiCloudPercentOutline } from '@mdi/js';
import Icon from '@mdi/react';
import { RadialGauge, RadialGaugeOptions } from 'canvas-gauges';
import React, { useEffect, useRef } from 'react';

interface AmbientData {
  [key: string]: any; // Allows for other fields like temp, humidity, etc.
}

interface GaugePressureProps {
  size?: number;
  data: AmbientData;
}

export const GaugePressure: React.FC<GaugePressureProps> = ({ size = 300, data }) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const gaugeRef = useRef<RadialGauge | null>(null);

  // Convert Fahrenheit to Celsius as a number for the gauge needle


  useEffect(() => {
    if (!canvasRef.current) return;

    const options: RadialGaugeOptions = {
      renderTo: canvasRef.current,
      width: size,
      height: size,
      minValue: 26,
      maxValue: 33,
      majorTicks: ["26", "27", "28", "29", "30", "31", "32", "33"],
      minorTicks: 10,
      ticksAngle: 270,
      startAngle: 45,
      strokeTicks: false,
      highlights: [
      ],
      colorPlate: "#fff",
      colorMajorTicks: "#000",
      colorMinorTicks: "#777",
      colorNumbers: "#000",
      colorNeedle: "red",
      colorNeedleEnd: "red",
      valueBox: false,
      needleType: "line",
      needleStart: 75,
      needleEnd: 99,
      needleWidth: 3,
      borders: true,
      borderOuterWidth: 0,
      colorBorderOuter: "#ddd",
      animationRule: "linear",
      animationDuration: 1000,
      value: (data.baromabsin || 0).toFixed(2),
      needleCircleSize: 1,
    };

    gaugeRef.current = new RadialGauge(options).draw();

    return () => gaugeRef.current?.destroy();
  }, [size]);

  // Update needle when temperature changes
  useEffect(() => {
    if (gaugeRef.current) {
      gaugeRef.current.value = (data.baromabsin || 0).toFixed(2)
    }
  }, [data.baromabsin]);

  return (


    <div style={{
      position: 'relative',
      width: size,
      height: size,
      margin: '0 auto'
    }}>
      <canvas ref={canvasRef} />
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none', fontFamily: 'Arial, sans-serif', }}>
        <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
          <div style={{ fontSize: `${size * 0.12}px`, fontWeight: 'bold', letterSpacing: "-1px", color: '#000' }}>
            {(data.baromabsin || 0).toFixed(2)}
          </div>

          <div style={{ fontSize: `${size * 0.05}px`, color: '#666', textTransform: 'uppercase', marginTop: '-2px' }}>
            inHg
          </div>
          <div style={{ fontSize: `${size * 0.07}px`, color: '#444', fontWeight: '600', letterSpacing: '0.5px' }}>
            <span><Icon path={mdiCloudPercentOutline} size={1} />{(data.humidity)}%</span>
          </div>
        </div>

      </div>


    </div>


  );
};

export default GaugePressure; 
